/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const userDirectoryPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userDirectoryPageResponseOutputItemsItemDisplayNameMax = 200;

export const userDirectoryPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const userDirectoryPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const userDirectoryPageResponseOutputItemsItemMembershipCountMin = 0;
export const userDirectoryPageResponseOutputItemsItemMembershipCountMax = 9007199254740991;

export const userDirectoryPageResponseOutputNextCursorOneMax = 512;

export const userDirectoryPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const UserDirectoryPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(userDirectoryPageResponseOutputItemsItemIdRegExp),
      displayName: zod.string().min(1).max(userDirectoryPageResponseOutputItemsItemDisplayNameMax),
      corporateState: zod.enum(['active', 'deactivated']),
      role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
      version: zod
        .int()
        .gt(userDirectoryPageResponseOutputItemsItemVersionExclusiveMin)
        .max(userDirectoryPageResponseOutputItemsItemVersionMax),
      membershipCount: zod
        .int()
        .min(userDirectoryPageResponseOutputItemsItemMembershipCountMin)
        .max(userDirectoryPageResponseOutputItemsItemMembershipCountMax),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(userDirectoryPageResponseOutputNextCursorOneMax)
      .regex(userDirectoryPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type UserDirectoryPageResponseOutput = zod.input<typeof UserDirectoryPageResponseOutput>;
export type UserDirectoryPageResponseOutputOutput = zod.output<
  typeof UserDirectoryPageResponseOutput
>;
